import { DatePicker } from 'antd';

export const AntDatePicker = DatePicker;
export const AntRangePicker = DatePicker.RangePicker;
